export const getCard = id => window.rattea.cards[id];

export const cardImageUrl = image =>
    `/images/cards/${image}.svg?${process.env.MIX_CARDS_VERSION}`;
